import actionTypes from './actionTypes';

const initialState = {
  shipment: {
    sid: null,
    iid: null,
    quote: {},
    summary: {},
  },
  isFetching: true,
  shipmentFailedToLoad: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        shipment: initialState.shipment,
        isFetching: true,
        shipmentFailedToLoad: false,
      };
    case actionTypes.FETCHING:
      return {
        ...state,
        shipment: initialState.shipment,
        isFetching: true,
      };
    case actionTypes.FETCHED:
      return {
        ...state,
        shipment: action.payload.shipment,
        isFetching: false,
        shipmentFailedToLoad: false,
      };
    case actionTypes.FAILED:
      return {
        ...state,
        isFetching: false,
        shipmentFailedToLoad: true,
      };
    case actionTypes.UPDATE_DISTANCE:
      return {
        ...state,
        shipment: {
          ...state.shipment,
          summary: {
            ...state.shipment.summary,
            distance: action.payload.distance,
          },
        },
      };
    case actionTypes.UPDATE_DURATION:
      return {
        ...state,
        shipment: {
          ...state.shipment,
          summary: {
            ...state.shipment.summary,
            duration: action.payload.duration,
          },
        },
      };
    case actionTypes.UPDATE_STATUS:
      return {
        ...state,
        shipment: {
          ...state.shipment,
          quote: {
            ...state.shipment.quote,
            status: action.payload.status,
          },
        },
      };
    case actionTypes.UPDATE_LOCATION:
      return {
        ...state,
        shipment: {
          ...state.shipment,
          summary: {
            ...state.shipment.summary,
            location: action.payload.location,
          },
        },
      };
    default:
      return state;
  }
};
